export enum SectionIds {
  "home" = "home",
  "home-simple" = "home-simple",
  "home-native" = "home-native",
  "home-targeted" = "home-targeted",
  "home-syntax" = "home-syntax",
  "home-scope" = "home-scope",
  "home-docs" = "home-docs",
  "home-template-simple" = "home-template-simple",
  "home-template-rx" = "home-template-rx",
  "home-template-rxfunc" = "home-template-rxfunc",
  "home-install" = "home-install",
  "home-bootstrap" = "home-bootstrap",
  "home-example-1" = "home-example-1",
  "home-example-2" = "home-example-2",
  "home-router-code" = "home-router-code",
  "home-http-code" = "home-http-code",
  "docs" = "docs",
  "template-engine" = "template-engine",
  "template-engine-js-subset" = "template-engine-js-subset",
  "template-engine-attached" = "template-engine-attached",
  "template-engine-events" = "template-engine-events",
  "template-engine-let" = "template-engine-let",
  "template-engine-inner-html" = "template-engine-inner-html",
  "template-engine-once" = "template-engine-once",
  "template-engine-repeat" = "template-engine-repeat",
  "template-engine-repeat-key" = "template-engine-repeat-key",
  "template-engine-rx" = "template-engine-rx",

  "tests" = "tests",
  "tests-intro" = "tests-intro",
  "benchmark-grid" = "benchmark-grid",
  "tests-text" = "tests-text",
  "tests-list" = "tests-list",
  "tests-mount" = "tests-mount",
  "tests-events" = "tests-events",
  "tests-empty" = "tests-empty",
  "tests-null" = "tests-null",
  "tests-conditional" = "tests-conditional",
  "tests-nested" = "tests-nested",
  "web3" = "web3",
  "web3-intro" = "web3-intro",
  "web3-sign" = "web3-sign",
  "web3-secret-auth" = "web3-secret-auth",
  "router" = "router",
  "router-routes" = "router-routes",
  "router-navigation" = "router-navigation",
  "router-bucket" = "router-bucket",
  "router-hash-mode" = "router-hash-mode",
  "router-load-resources" = "router-load-resources",
  "http" = "http",
  "http-interceptors" = "http-interceptors",
  "http-cache" = "http-cache",
  "component" = "component",
  "service" = "service",
  "cmp-interaction" = "cmp-interaction",
  "cmp-interaction-attributes" = "cmp-interaction-attributes",
  "cmp-interaction-advantages" = "cmp-interaction-advantages",
  "ui-components" = "ui-components",
  "ui-components-input" = "ui-components-input",
  "ui-components-textarea" = "ui-components-textarea",
  "ui-components-button-group" = "ui-components-button-group",
  "ui-components-upload" = "ui-components-upload",
  "ui-components-select" = "ui-components-select",
  "ui-components-spinner" = "ui-components-spinner",
  "ui-components-modal" = "ui-components-modal",
  "ui-components-toast" = "ui-components-toast",
  "ui-components-css-classes" = "ui-components-css-classes",
  "demo-lazy-page" = "demo-lazy-page",
}

type SectionsMap = Partial<
  Record<SectionIds, { demos?: Partial<Record<number, string>> }>
> | null | undefined;

export function getDemoDesc(
  sections: SectionsMap,
  id: SectionIds | string,
  index: number,
): string {
  return sections?.[id as SectionIds]?.demos?.[index] ?? "";
}